import { deleteCategoriesAction, fetchCategoriesAction } from "./actions";
import { push } from "connected-react-router";
import { FirebaseTimestamp, db } from "../../firebase";
import {
  collection,
  doc,
  getDocs,
  deleteDoc,
  orderBy,
  updateDoc,
  addDoc,
  setDoc,
  writeBatch,
  query,
  documentId,
  where,
  Timestamp,
  getDoc,
} from "firebase/firestore";

const categoriessRef = collection(db, "categories");

export const saveCategories = (newCategories) => {
  return async (dispatch) => {
    const categories = await fetchCategoriesWithNoRedux();
    const timestamp = FirebaseTimestamp.now();
    const batch = [];

    // 1. categoriesに存在し、newCategoriesに存在しないカテゴリを削除
    categories.forEach((category) => {
      const categoryExistsInNew = newCategories.some(
        (newCategory) => newCategory.id === category.id
      );
      if (!categoryExistsInNew) {
        //存在しなかったら
        const docRef = doc(db, "categories", category.id);
        batch.push(deleteDoc(docRef));
      }
    });

    // 2. newCategoriesに存在し、categoriesに存在しないカテゴリを追加
    newCategories.forEach((newCategory) => {
      const categoryExistsInCategories = categories.some(
        (category) => category.id === newCategory.id
      );
      if (!categoryExistsInCategories) {
        //存在しなかったら
        const data = {
          id: "",
          cid: newCategory.cid,
          name: newCategory.name,
          deducation: newCategory.deducation,
          limit: newCategory.limit,
          updated_at: timestamp,
          created_at: timestamp,
        };
        batch.push(addNewDocument(data));
      }
    });

    // 3. categoriesとnewCategoriesの両方に存在するカテゴリを更新
    newCategories.forEach((newCategory) => {
      const categoryExistsInCategories = categories.some(
        (category) => category.id === newCategory.id
      );
      if (categoryExistsInCategories) {
        const categoryToUpdate = categories.find(
          (category) => category.id === newCategory.id
        );
        if (JSON.stringify(categoryToUpdate) !== JSON.stringify(newCategory)) {
          const docRef = doc(db, "categories", newCategory.id);
          const data = {
            id: newCategory.id,
            cid: newCategory.cid,
            name: newCategory.name,
            deducation: newCategory.deducation,
            limit: newCategory.limit,
            updated_at: timestamp,
          };
          batch.push(updateDoc(docRef, data, { merge: true }));
        }
      }
    });

    try {
      await Promise.all(batch);
      dispatch(push("/"));
    } catch (error) {
      console.error("Error synchronizing categories: ", error);
      throw new Error(error);
    }
  };
};

const addNewDocument = async (newData) => {
  const collectionRef = collection(db, "categories");

  try {
    const docRef = await addDoc(collectionRef, newData);
    const newDocumentId = docRef.id;
    const newDataWithId = { ...newData, id: newDocumentId };
    const docRefToUpdate = doc(db, "categories", newDocumentId);
    await updateDoc(docRefToUpdate, newDataWithId);
  } catch (error) {
    console.error("Error adding document: ", error);
  }
};

export const fetchCategories = () => {
  return async (dispatch) => {
    const q = query(collection(db, "categories"), orderBy("cid", "asc"));
    const querySnapshot = await getDocs(q);
    const list = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      list.push({
        id: data.id,
        cid: data.cid,
        name: data.name,
        deducation: data.deducation,
        limit: data.limit,
      });
    });
    //console.trace("list:",list);
    dispatch(fetchCategoriesAction(list));
  };
};

const fetchCategoriesWithNoRedux = async () => {
  const q = query(collection(db, "categories"), orderBy("id", "asc"));
  const querySnapshot = await getDocs(q);
  const list = [];
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    list.push({
      id: doc.id,
      cid: data.cid,
      name: data.name,
      deducation: data.deducation,
      limit: data.limit,
    });
  });
  return list;
};
